import React, { useState } from "react";

function TestCode() {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchFlightSearch = async () => {
    setLoading(true);
    setError(""); // Clear previous errors
    setResponse(null); // Clear previous responses

    const headers = {
      "x-Username": "test283469", // Replace with your username
      "x-Password": "test@283", // Replace with your password
      "x-System": "test", // Specify whether test or live
      "x-DomainKey": "TMX5602831669199256", // Replace with your DomainKey
      "Content-Type": "application/json",
    };

    const body = JSON.stringify({
      AdultCount: "1",
      ChildCount: "0",
      InfantCount: "0",
      JourneyType: "OneWay",
      PreferredAirlines: [""],
      CabinClass: "Economy",
      Segments: [
        {
          Origin: "BLR",
          Destination: "MAA",
          DepartureDate: "2024-04-25T00:00:00",
        },
      ],
    });

    try {
      const res = await fetch(
        "http://test.services.travelomatix.com/webservices/index.php/flight/service/Search",
        {
          method: "POST",
          headers: headers,
          body: body,
        }
      );

      if (res.ok) {
        const result = await res.json();
        console.log("API Response:", result);
        setResponse(result);
      } else {
        const errorMsg = `Error: ${res.status} ${res.statusText}`;
        console.error(errorMsg);
        setError(errorMsg);
      }
    } catch (err) {
      console.error("Request Error:", err.message);
      setError("An error occurred while fetching data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1>Flight Search</h1>
      <button
        onClick={fetchFlightSearch}
        className="btn btn-primary"
        disabled={loading}
      >
        {loading ? "Loading..." : "Search Flights"}
      </button>

      {response && (
        <div>
          <h3>Flight Search Results</h3>
          <pre>{JSON.stringify(response, null, 2)}</pre>
        </div>
      )}

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
}

export default TestCode;
